<template>
    <div class="kanban-container" ref="kanban">
        <div style="height:60px;display:flex;">

            <img style="height:30px;margin: 15px 70px 15px 90px;" :src="require('../../assets/p-kb-1.png')" />
            <span class="production-kb-header">考勤看<span @click="start">板</span></span>

            <img style="height:30px;margin-top:15px;margin-left: 75px;margin-right: 75px;"
                :src="require('../../assets/p-kb-1.png')" />

            <div class="production-kb-header" style="font-size:23px ;">{{ currentTime }}</div>
        </div>

        <div style="display: flex;">
            <div style="overflow: auto;width:50%;height: 570px;">
                <table class="kb-table">
                    <tr>
                        <td style="width: 15px;max-width: 10px;">姓名</td>

                        <td style="width: 20px;max-width: 20px;">上班1</td>
                        <td style="width: 20px;max-width: 20px;">下班1</td>

                        <td style="width: 20px;max-width: 20px;">上班2</td>
                        <td style="width: 20px;max-width: 20px;">下班2</td>
                        <!-- <td style="width: 20px;max-width: 20px;">上班3</td> -->
                        <!-- <td style="width: 20px;max-width: 20px;">下班3</td> -->
                    </tr>

                    <tr v-for="(item, index) in checkWorkList" :key="index" :class="index == 0 ? 'kanban-tr-one' : ''">

                        <td>{{ item.employeeName }}</td>

                        <td>{{ item.onDutyOne }}</td>
                        <td>{{ item.offDutyOne }}</td>

                        <td>{{ item.onDutyTwo }}</td>
                        <td>{{ item.offDutyTwo }}</td>

                        <!-- <td>{{ item.onDutyThree }}</td> -->
                        <!-- <td>{{ item.offDutyThree }}</td> -->
                    </tr>

                </table>
            </div>

            <div style="width:30%;">

                <qr-code :text="text" :key="key" style="position: absolute;top: 100px;left: 300px;" />

                <div style="display: flex;">
                    <table class="kb-table" style="width:30%">
                        <tr>
                            <td style="width: 5px;">姓名</td>

                            <td style="width: 5px;">年补卡</td>
                            <!-- <td style="width: 10px;max-width: 10px;">月补卡</td> -->
                        </tr>

                        <tr v-for="(item, index) in absenceList" :key="index" style="color:orange">

                            <td>{{ item.employeeName }}</td>

                            <td>{{ item.ycount }}</td>
                            <!-- <td>{{ item.mcount }}</td> -->
                        </tr>
                    </table>

                    <table class="kb-table">
                        <tr>
                            <td style="width: 4px;">姓名</td>

                            <td style="width: 4px;">月补卡</td>
                            <td style="width: 13px;">事由</td>
                            <td style="width: 4px;">年补卡</td>
                        </tr>

                        <tr v-for="(item, index) in absenceList2" :key="index"
                            :class="index == 0 ? 'kanban-tr-one' : ''" style="color:skyblue">

                            <td>{{ item.employeeName }}</td>

                            <td>{{ item.mcount }}</td>
                            <td>{{ item.remark }}</td>
                            <td>{{ item.ycount }}</td>
                        </tr>
                    </table>
                </div>

            </div>
        </div>

        <el-dialog title="请输入" :visible.sync="dlgFormVisible" width="30%">

            <div style="width: 100%;">
                <div style="display: flex;" class="secret-n">
                    <div @click="press(7)">7</div>
                    <div @click="press(8)">8</div>
                    <div @click="press(9)">9</div>
                </div>
                <div style="display: flex;" class="secret-n">
                    <div @click="press(4)">4</div>
                    <div @click="press(5)">5</div>
                    <div @click="press(6)">6</div>
                </div>
                <div style="display: flex;" class="secret-n">
                    <div @click="press(1)">1</div>
                    <div @click="press(2)">2</div>
                    <div @click="press(3)">3</div>
                </div>
            </div>

            <div slot="footer" class="dialog-footer">
                <el-button @click="dlgFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="confirm">确 定</el-button>
            </div>
        </el-dialog>

        <div style="height: 10px;"></div>

        <div style="position: absolute;right: 30px;bottom: 5px;">
            <i class="el-icon-full-screen" @click="fullDisplay" style="color:orange"></i>
        </div>
    </div>
</template>

<script>
import QrCode from "../../components/QrCode.vue"

export default {
    name: "ChkWorkTV",
    components: {
        QrCode
    },
    data() {
        return {
            companyId: '',
            companyName: '大公司',

            dlgFormVisible: false,
            secretValue: 0,
            pressCount: 0,

            key: 0,
            text: new Date().getTime() + '',

            checkWorkList: [],
            createdTime: new Date(),
            currentTime: '',

            absenceList: [],
            absenceList2: []
        }
    },
    methods: {
        getAll() {
            this.$axios({
                method: "post",
                url: "/shiro/check/work/forKB",
                data: {
                    createdTime: this.createdTime,
                    status: -1,
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.checkWorkList = data.data

                this.currentTime = this.$moment(new Date()).format("YYYY-MM-DD HH:mm")
            })
        },
        getCurrentTime() {
            this.$axios({
                method: "post",
                url: "/shiro/check/work/getTime",
                data: {},
                headers: {}
            }).then(result => {

                this.key += 1
                this.text = result.data + ''
            })
        },
        getAbsence() {
            this.$axios({
                method: "post",
                url: "/shiro/abs/apply/getCount",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.absenceList = data.data
            })
        },
        getForMonth() {
            this.$axios({
                method: "post",
                url: "/shiro/abs/apply/getMonth",
                data: {
                    companyId: this.companyId
                },
                headers: {
                    token: this.token
                }
            }).then(result => {

                const data = result.data

                this.absenceList2 = data.data
            })
        },
        fullDisplay() {

            let element = this.$refs.kanban

            if (this.fullscreen) {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen()
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            } else {
                if (element.requestFullscreen) {
                    element.requestFullscreen()
                } else if (element.webkitRequestFullScreen) {
                    element.webkitRequestFullScreen()
                } else if (element.mozRequestFullScreen) {
                    element.mozRequestFullScreen()
                } else if (element.msRequestFullscreen) {
                    element.msRequestFullscreen()
                }
            }

            this.fullscreen = !this.fullscreen
        },
        press(value) {

            this.pressCount++

            this.secretValue += value
        },
        confirm() {

            const today = new Date()
            var dayOfWeek = today.getDay()

            const date = today.getDate()

            //星期天
            if (dayOfWeek == 0) {
                dayOfWeek++
            }

            if (date < dayOfWeek) {
                this.pressCount = this.pressCount + (dayOfWeek - date)
            }

            if (this.pressCount % dayOfWeek == 0 && date == this.secretValue) {

                this.timer = setInterval(() => {

                    this.getCurrentTime()

                }, 5000)
            }

            this.dlgFormVisible = false
        },
        start() {
            this.pressCount = 0
            this.secretValue = 0

            this.dlgFormVisible = true
        }
    },
    created() {

        let url = window.location.href

        let str = url.substring(url.indexOf('?') + 1)
        let arrs = str.split('&')
        let result = {}

        arrs.forEach(item => {
            let keyArr = item.split('=')
            let name = keyArr[0]
            let value = keyArr[1]
            result[name] = value
        })

        if (Object.keys(result).length >= 1) {

            this.companyId = result.cid
        }
    },
    mounted() {

        this.timer = setInterval(() => {

            this.getCurrentTime()

        }, 5000)

        this.timer2 = setInterval(() => {

            this.getAll()

            this.getAbsence()

            this.getForMonth()

        }, 60000)

    }
}
</script>

<style>
.kanban-container {
    width: 100%;
    height: 640px;
    color: white;
    background-color: #06207D;
    box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    position: relative;
}

.production-kb-header {
    font-size: 25px;
    font-weight: bolder;
    color: white;
    line-height: 60px;
}

.kb-table {
    width: 100%;
    table-layout: fixed;
    border: 1px solid white;
    font-size: 13px;
    font-weight: bold;
    color: white;
    border-collapse: collapse;
    border-spacing: 1px;
}

.kanban-tr-one {
    font-size: 14px;
    font-weight: bold;
}

.secret-n div {
    width: 32%;
    height: 30px;
    line-height: 30px;
    border: orange solid 1px;
}
</style>